<template>
    <Dialog v-model:open="opnened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <template #icon>
                    <CreditCard
                        class="text-z-primary-600"
                        stroke-width="2.25"
                        :size="20"
                    />
                </template>
                <DialogTitle>
                    {{ $t("billing.switch_billing_period_modal.title") }}
                </DialogTitle>
                <DialogDescription>
                    {{ $t("billing.switch_billing_period_modal.description") }}
                </DialogDescription>
            </DialogHeader>
            <div class="px-6 pt-6">
                <p class="text-iron-600">
                    {{
                        switchPlan.recurring === "monthly"
                            ? $t("billing.switch_billing_period_modal.monthly")
                            : $t("billing.switch_billing_period_modal.yearly")
                    }}
                </p>
            </div>

            <DialogFooter>
                <DialogClose>
                    <Button variant="outline"> {{ $t("cancel") }}</Button>
                </DialogClose>
                <Button
                    @click="updateSubscription"
                    :loading="form.processing"
                    :recently-successful="form.recentlySuccessful"
                >
                    {{ $t("update") }}</Button
                >
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { Button } from "@/components/ui/button";
import { ref } from "vue";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogClose,
} from "@/components/ui/dialog-v2";
import { CreditCard } from "lucide-vue-next";
import { Plan } from "../types";
import { useForm } from "@inertiajs/vue3";
import route from "ziggy-js";

const opnened = ref(false);

interface Props {
    switchPlan: Plan;
    teamId?: number;
}

const props = defineProps<Props>();

const form = useForm({
    plan: props.switchPlan.plan_id,
});

async function updateSubscription(plan?: string) {
    if (plan === undefined) {
        return;
    }

    form.post(route("app.subscription.update", { team: props.teamId }), {
        onError: (error) => {
            console.error(error);
        },
        onSuccess: () => {
            opnened.value = false;
        },
    });
}
</script>
